import { GANHE_MAIS_CORRETOR_CLIENT_URL } from '../../../../constants/ClientUrls';
import styles from './RegisterFormInfluencer.module.css';

import { useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { Button } from '../../../../components/Button';
import { Card } from '../../../../components/Card';
import { FloatVideoCta } from '../../../../components/FloatVideoCta';
import { Input } from '../../../../components/forms/Input';
import { Notify, NotifyUpdate } from '../../../../components/Notify';

import * as routes from '../../../../constants/Routes';
import { useAuth } from '../../../../hooks/useAuth';
import { api } from '../../../../server/api';
import { MaskCNPJ, MaskCPF } from '../../../../utils/mask';
import { validateCNPJ, validateCPF } from '../../../../utils/validate';

interface FormValues {
  firstName: string;
  lastName: string;
  email: string;
  confirmEmail: string;
  password: string;
  confirmPassword: string;
  cpf: string;
  acceptedTerms: boolean;
}

export function RegisterFormInfluencer() {
  const { client, signIn } = useAuth();
  const navigate = useNavigate();
  const [isEmailInfluencer, setIsEmailInfluencer] = useState<boolean>();
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors, isSubmitting },
  } = useForm<FormValues>();

  const checkEmailIsInfluencer = async () => {
    try {
      const parameters = {
        email: getValues('email'),
        clientId: client.id,
      };

      const { data } = await api.post('/v2/checkIsInfluencerEmail', parameters);
      if (data.success) setIsEmailInfluencer(data ? data.isInfluencer : false);
    } catch (error) {
      console.log('error checkEmailIsInfluencer');
      setIsEmailInfluencer(false);
    }
  };

  const handleForm = handleSubmit(async (formData) => {
    try {
      if (formData.email !== formData.confirmEmail) {
        return Notify('Confirme os emails', 'warn');
      }
      if (formData.password !== formData.confirmPassword) {
        return Notify('Confirme as senhas', 'warn');
      }

      if (client && client.clientUrl === GANHE_MAIS_CORRETOR_CLIENT_URL) {
        if (!validateCNPJ(formData.cpf)) {
          return Notify('Insira um cnpj válido', 'warn');
        }
      } else if (formData.cpf.length === 14) {
        if (!validateCPF(formData.cpf)) {
          return Notify('Insira um cpf válido', 'warn');
        }
      } else {
        if (!validateCNPJ(formData.cpf)) {
          return Notify('Insira um cnpj válido', 'warn');
        }
      }

      await checkEmailIsInfluencer();
      const newPlayerData = {
        name: `${formData.firstName} ${formData.lastName}`,
        ...formData,
        clientId: client.id,
      };

      let nId = Notify('Criando sua conta...', 'loading');

      const parameters = {
        player: newPlayerData,
        targetPublic: client.targetPublic,
        page: 'registergameinfluencers',
      };

      const { data } = await api.post('/createPlayer', parameters);
      nId = Notify('Validando dados...', 'loading');

      if (!data.success) {
        return NotifyUpdate(data.message, 'error', nId);
      }
      const responseSignIn = await signIn({
        email: formData.email,
        password: formData.password,
        clientId: client.id,
      });

      NotifyUpdate(
        responseSignIn.message,
        responseSignIn.success ? 'success' : 'error',
        nId
      );

      if (isEmailInfluencer) {
        navigate(routes.VALIDATION_CODE);
      } else {
        // navigate(routes.REGISTER_DETAILS);
      }
    } catch (error) {
      console.log('erro handleForm', error);
    }
  });

  const onHandleLogin = () => {
    navigate(routes.START);
  };

  const renderInactiveClient = () => {
    return (
      <div className={styles.inactiveBox}>
        <i className={`material-icons-outlined ${styles.iconLogo}`}>
          domain_disabled
        </i>
        <p>Cliente inativo</p>
        <a href="https://oqdigital.com" className={styles.btnInactiveOutlined}>
          <i className="material-icons-outlined">arrow_back</i>
          Voltar ao site
        </a>
      </div>
    );
  };

  const renderFormInfluencer = () => {
    return (
      <>
        <form onSubmit={handleForm}>
          <div className="m-3">
            <Card>
              <div className="mb-3">
                <Input
                  type="text"
                  placeholder="Nome"
                  {...register('firstName', {
                    required: true,
                  })}
                  errors={errors.firstName ? 'Campo obrigatório' : ''}
                />
              </div>
              <div className="mb-3">
                <Input
                  type="text"
                  placeholder="Sobrenome"
                  {...register('lastName', {
                    required: true,
                  })}
                  errors={errors.lastName ? 'Campo obrigatório' : ''}
                />
              </div>
              <div className="mb-3">
                <Input
                  type="text"
                  placeholder="E-mail"
                  {...register('email', {
                    required: true,
                  })}
                  errors={errors.email ? 'Campo obrigatório' : ''}
                />
              </div>
              <div className="mb-3">
                <Input
                  type="text"
                  placeholder="Confirmar e-mail"
                  {...register('confirmEmail', {
                    required: true,
                  })}
                  errors={errors.confirmEmail ? 'Campo obrigatório' : ''}
                />
              </div>
              <div className="mb-3">
                <Input
                  type="password"
                  placeholder="Senha"
                  {...register('password', {
                    required: true,
                  })}
                  errors={errors.password ? 'Campo obrigatório' : ''}
                />
              </div>
              <div className="mb-3">
                <Input
                  type="password"
                  placeholder="Confirmar senha"
                  {...register('confirmPassword', {
                    required: true,
                  })}
                  errors={errors.confirmPassword ? 'Campo obrigatório' : ''}
                />
              </div>
              <div className="mb-3">
                <Input
                  maxLength={18}
                  minLength={
                    client &&
                    client.clientUrl === GANHE_MAIS_CORRETOR_CLIENT_URL
                      ? 18
                      : 11
                  }
                  type="text"
                  placeholder={
                    client &&
                    client.clientUrl === GANHE_MAIS_CORRETOR_CLIENT_URL
                      ? 'CNPJ'
                      : 'CPF/CNPJ'
                  }
                  {...register('cpf', {
                    required: true,
                  })}
                  errors={errors.cpf ? 'Campo obrigatório' : ''}
                  onChange={(event) => {
                    const { value } = event.target;

                    if (
                      client &&
                      client.clientUrl === GANHE_MAIS_CORRETOR_CLIENT_URL
                    ) {
                      event.target.value = MaskCNPJ(value);
                    } else if (value.length <= 14) {
                      event.target.value = MaskCPF(value);
                    } else {
                      event.target.value = MaskCNPJ(value);
                    }
                  }}
                />
              </div>
              <div className="d-grid">
                <Button
                  icon="check"
                  text={isSubmitting ? 'Cadastrando' : 'Cadastrar'}
                  type="submit"
                  color="primary"
                  isLoading={isSubmitting}
                  disabled={isSubmitting}
                />
              </div>
              <div className="mt-3">
                <div className="d-grid">
                  <Button
                    text="Fazer login"
                    icon="login"
                    onClick={onHandleLogin}
                  />
                </div>
              </div>
            </Card>
          </div>
        </form>
      </>
    );
  };

  return (
    <div
      style={{
        background: isMobile ? '' : `url(${client.loginImage})`,
      }}
      className={`${styles.contentFull} ${styles.backgroundImage}`}
    >
      {client && client.urlVideoLogin && (
        <FloatVideoCta videoUrl={client.urlVideoLogin} />
      )}
      <div className={styles.contentLeft}>
        {isMobile && (
          <img
            className="img-fluid"
            src={
              client && client.loginImageMobile
                ? client.loginImageMobile
                : client.loginImage
            }
          />
        )}
      </div>
      <div className={styles.contentRight}>
        <div className={styles.centeredAllFlex}>
          {client && client.active
            ? renderFormInfluencer()
            : renderInactiveClient()}
        </div>
      </div>
    </div>
  );
}
